import React from 'react';
import { useTheme, alpha } from '@mui/material/styles';

type ColorVariant = 'primary' | 'secondary';

interface CustomToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  color?: ColorVariant;
}

export const CustomToggle: React.FC<CustomToggleProps> = ({
  checked,
  onChange,
  disabled = false,
  color = 'primary',
}) => {
  const theme = useTheme();

  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  // Main color
  const activeColor =
    color === 'primary'
      ? theme.palette.primary.main
      : theme.palette.secondary.main;

  // Faded background color for the track
  const fadedTrackColor = checked
    ? alpha(activeColor, 0.35) // 35% opacity
    : 'rgba(0,0,0,0.38)';

  return (
    <div
      onClick={handleClick}
      style={{
        width: '34px',
        height: '12px',
        borderRadius: '6px',
        backgroundColor: fadedTrackColor,
        position: 'relative',
        cursor: disabled ? 'default' : 'pointer',
        transition: 'background-color 0.3s',
        display: 'flex',
        alignItems: 'center',
        padding: '2px',
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <div
        style={{
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          backgroundColor: checked ? activeColor : '#fff',
          transform: checked ? 'translateX(14px)' : 'translateX(-3px)',
          transition: 'transform 0.3s, background-color 0.3s',
          boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
        }}
      />
    </div>
  );
};
